import { createContext, useContext, useState, useEffect, type ReactNode } from "react";

interface SynthwaveContextType {
  isSynthwaveEnabled: boolean;
  toggleSynthwave: () => void;
}

const SynthwaveContext = createContext<SynthwaveContextType | undefined>(undefined);

export function SynthwaveProvider({ children }: { children: ReactNode }) {
  const [isSynthwaveEnabled, setIsSynthwaveEnabled] = useState<boolean>(() => {
    // Load from localStorage on initial mount
    // Default to true (enabled) if not set
    if (typeof window !== "undefined") {
      const saved = localStorage.getItem("synthwaveEnabled");
      return saved === null ? true : saved === "true";
    }
    return true;
  });

  useEffect(() => {
    // Save to localStorage whenever mode changes
    localStorage.setItem("synthwaveEnabled", String(isSynthwaveEnabled));
  }, [isSynthwaveEnabled]);

  const toggleSynthwave = () => {
    setIsSynthwaveEnabled((prev) => !prev);
  };

  return (
    <SynthwaveContext.Provider value={{ isSynthwaveEnabled, toggleSynthwave }}>
      {children}
    </SynthwaveContext.Provider>
  );
}

export function useSynthwave() {
  const context = useContext(SynthwaveContext);
  if (context === undefined) {
    throw new Error("useSynthwave must be used within a SynthwaveProvider");
  }
  return context;
}

